import axios from "axios";

export default {
  namespaced: true,
  state: {
    low_stock_report: null,
    out_of_stock_report: null,
    fastest_moving_report: null,
    slow_moving_report: null,
    stock_movement_report: null,
    turnover_report: null,
    supplier_performance_report: null,
    stock_position_report: null,
    loading: false,
  },
  getters: {
    low_stock_report(state) {
      return state.low_stock_report;
    },
    out_of_stock_report(state) {
      return state.out_of_stock_report;
    },
    fastest_moving_report(state) {
      return state.fastest_moving_report;
    },
    slow_moving_report(state) {
      return state.slow_moving_report;
    },
    stock_movement_report(state) {
      return state.stock_movement_report;
    },
    turnover_report(state) {
      return state.turnover_report;
    },
    supplier_performance_report(state) {
      return state.supplier_performance_report;
    },
    stock_position_report(state) {
      return state.stock_position_report;
    },
    loading(state) {
      return state.loading;
    },
  },
  mutations: {
    SET_LOW_STOCK_REPORT(state, data) {
      state.low_stock_report = data;
    },
    SET_OUT_OF_STOCK_REPORT(state, data) {
      state.out_of_stock_report = data;
    },
    SET_FASTEST_MOVING_REPORT(state, data) {
      state.fastest_moving_report = data;
    },
    SET_SLOW_MOVING_REPORT(state, data) {
      state.slow_moving_report = data;
    },
    SET_STOCK_MOVEMENT_REPORT(state, data) {
      state.stock_movement_report = data;
    },
    SET_TURNOVER_REPORT(state, data) {
      state.turnover_report = data;
    },
    SET_SUPPLIER_PERFORMANCE_REPORT(state, data) {
      state.supplier_performance_report = data;
    },
    SET_STOCK_POSITION_REPORT(state, data) {
      state.stock_position_report = data;
    },
    SET_LOADING(state, val) {
      state.loading = val;
    },
  },
  actions: {
    async get_low_stock_report({ commit }, params = {}) {
      commit("SET_LOADING", true);
      try {
        let response = await axios.get("/inventory_reports/low_stock", {
          params,
        });
        commit("SET_LOW_STOCK_REPORT", response.data);
        return response.data;
      } finally {
        commit("SET_LOADING", false);
      }
    },
    async get_out_of_stock_report({ commit }, params = {}) {
      commit("SET_LOADING", true);
      try {
        let response = await axios.get("/inventory_reports/out_of_stock", {
          params,
        });
        commit("SET_OUT_OF_STOCK_REPORT", response.data);
        return response.data;
      } finally {
        commit("SET_LOADING", false);
      }
    },
    async get_fastest_moving_report({ commit }, params = {}) {
      commit("SET_LOADING", true);
      try {
        let response = await axios.get("/inventory_reports/fastest_moving", {
          params,
        });
        commit("SET_FASTEST_MOVING_REPORT", response.data);
        return response.data;
      } finally {
        commit("SET_LOADING", false);
      }
    },
    async get_slow_moving_report({ commit }, params = {}) {
      commit("SET_LOADING", true);
      try {
        let response = await axios.get("/inventory_reports/slow_moving", {
          params,
        });
        commit("SET_SLOW_MOVING_REPORT", response.data);
        return response.data;
      } finally {
        commit("SET_LOADING", false);
      }
    },
    async get_stock_movement_report({ commit }, params = {}) {
      commit("SET_LOADING", true);
      try {
        let response = await axios.get("/inventory_reports/stock_movement", {
          params,
        });
        commit("SET_STOCK_MOVEMENT_REPORT", response.data);
        return response.data;
      } finally {
        commit("SET_LOADING", false);
      }
    },
    async get_turnover_report({ commit }, params = {}) {
      commit("SET_LOADING", true);
      try {
        let response = await axios.get("/inventory_reports/turnover", {
          params,
        });
        commit("SET_TURNOVER_REPORT", response.data);
        return response.data;
      } finally {
        commit("SET_LOADING", false);
      }
    },
    async get_supplier_performance_report({ commit }, params = {}) {
      commit("SET_LOADING", true);
      try {
        let response = await axios.get(
          "/inventory_reports/supplier_performance",
          { params }
        );
        commit("SET_SUPPLIER_PERFORMANCE_REPORT", response.data);
        return response.data;
      } finally {
        commit("SET_LOADING", false);
      }
    },
    async get_stock_position_report({ commit }, params = {}) {
      commit("SET_LOADING", true);
      try {
        let response = await axios.get("/inventory_reports/stock_position", {
          params,
        });
        commit("SET_STOCK_POSITION_REPORT", response.data);
        return response.data;
      } finally {
        commit("SET_LOADING", false);
      }
    },
  },
};
